// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/vectorizer/v2/service.proto (package creativefabrica.vectorizer.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Surface, SurfaceJson } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import { file_creativefabrica_common_v1_surface_v1_types } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import type { PaginationRequest, PaginationRequestJson, PaginationResponse, PaginationResponseJson } from "@repo/rpc-types-creativefabrica-common-v1";
import { file_creativefabrica_common_v1_types } from "@repo/rpc-types-creativefabrica-common-v1";
import { file_google_api_annotations } from "@repo/rpc-types-google-api/annotations";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/vectorizer/v2/service.proto.
 */
export const file_creativefabrica_vectorizer_v2_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_common_v1_surface_v1_types, file_creativefabrica_common_v1_types, file_google_api_annotations, file_google_protobuf_timestamp]);

/**
 * @generated from message creativefabrica.vectorizer.v2.MigrateAnonymousUserRequest
 */
export type MigrateAnonymousUserRequest = Message<"creativefabrica.vectorizer.v2.MigrateAnonymousUserRequest"> & {
  /**
   * @generated from field: string anonymous_user_id = 1;
   */
  anonymousUserId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.MigrateAnonymousUserRequest
 */
export type MigrateAnonymousUserRequestJson = {
  /**
   * @generated from field: string anonymous_user_id = 1;
   */
  anonymousUserId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.MigrateAnonymousUserRequest.
 * Use `create(MigrateAnonymousUserRequestSchema)` to create a new message.
 */
export const MigrateAnonymousUserRequestSchema: GenMessage<MigrateAnonymousUserRequest, {jsonType: MigrateAnonymousUserRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 0);

/**
 * @generated from message creativefabrica.vectorizer.v2.MigrateAnonymousUserResponse
 */
export type MigrateAnonymousUserResponse = Message<"creativefabrica.vectorizer.v2.MigrateAnonymousUserResponse"> & {
};

/**
 * @generated from message creativefabrica.vectorizer.v2.MigrateAnonymousUserResponse
 */
export type MigrateAnonymousUserResponseJson = {
};

/**
 * Describes the message creativefabrica.vectorizer.v2.MigrateAnonymousUserResponse.
 * Use `create(MigrateAnonymousUserResponseSchema)` to create a new message.
 */
export const MigrateAnonymousUserResponseSchema: GenMessage<MigrateAnonymousUserResponse, {jsonType: MigrateAnonymousUserResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 1);

/**
 * @generated from message creativefabrica.vectorizer.v2.GetImagesRequest
 */
export type GetImagesRequest = Message<"creativefabrica.vectorizer.v2.GetImagesRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string after_id = 2 [deprecated = true];
   * @deprecated
   */
  afterId: string;

  /**
   * @generated from field: int32 take = 3 [deprecated = true];
   * @deprecated
   */
  take: number;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 4;
   */
  pagination?: PaginationRequest | undefined;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.GetImagesRequest
 */
export type GetImagesRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: string after_id = 2 [deprecated = true];
   * @deprecated
   */
  afterId?: string;

  /**
   * @generated from field: int32 take = 3 [deprecated = true];
   * @deprecated
   */
  take?: number;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 4;
   */
  pagination?: PaginationRequestJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.GetImagesRequest.
 * Use `create(GetImagesRequestSchema)` to create a new message.
 */
export const GetImagesRequestSchema: GenMessage<GetImagesRequest, {jsonType: GetImagesRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 2);

/**
 * @generated from message creativefabrica.vectorizer.v2.GetImagesResponse
 */
export type GetImagesResponse = Message<"creativefabrica.vectorizer.v2.GetImagesResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.vectorizer.v2.Image images = 1;
   */
  images: Image[];

  /**
   * @generated from field: bool has_more = 2 [deprecated = true];
   * @deprecated
   */
  hasMore: boolean;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 3;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.GetImagesResponse
 */
export type GetImagesResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.vectorizer.v2.Image images = 1;
   */
  images?: ImageJson[];

  /**
   * @generated from field: bool has_more = 2 [deprecated = true];
   * @deprecated
   */
  hasMore?: boolean;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 3;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.GetImagesResponse.
 * Use `create(GetImagesResponseSchema)` to create a new message.
 */
export const GetImagesResponseSchema: GenMessage<GetImagesResponse, {jsonType: GetImagesResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 3);

/**
 * @generated from message creativefabrica.vectorizer.v2.InitiateRequest
 */
export type InitiateRequest = Message<"creativefabrica.vectorizer.v2.InitiateRequest"> & {
  /**
   * @generated from field: repeated creativefabrica.vectorizer.v2.BatchUrlRequestItem urls = 1;
   */
  urls: BatchUrlRequestItem[];

  /**
   * @generated from field: bool vectorize_immediately = 2;
   */
  vectorizeImmediately: boolean;

  /**
   * Product surface the session is created on. Stamped on the session and its
   * images, and scopes every later read and download. Unspecified means studio;
   * only studio and marketplace are accepted.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface: Surface;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.InitiateRequest
 */
export type InitiateRequestJson = {
  /**
   * @generated from field: repeated creativefabrica.vectorizer.v2.BatchUrlRequestItem urls = 1;
   */
  urls?: BatchUrlRequestItemJson[];

  /**
   * @generated from field: bool vectorize_immediately = 2;
   */
  vectorizeImmediately?: boolean;

  /**
   * Product surface the session is created on. Stamped on the session and its
   * images, and scopes every later read and download. Unspecified means studio;
   * only studio and marketplace are accepted.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.InitiateRequest.
 * Use `create(InitiateRequestSchema)` to create a new message.
 */
export const InitiateRequestSchema: GenMessage<InitiateRequest, {jsonType: InitiateRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 4);

/**
 * @generated from message creativefabrica.vectorizer.v2.InitiateResponse
 */
export type InitiateResponse = Message<"creativefabrica.vectorizer.v2.InitiateResponse"> & {
  /**
   * @generated from field: creativefabrica.vectorizer.v2.Session session = 1;
   */
  session?: Session | undefined;

  /**
   * @generated from field: repeated creativefabrica.vectorizer.v2.BatchUrlResponseItem urls = 2;
   */
  urls: BatchUrlResponseItem[];
};

/**
 * @generated from message creativefabrica.vectorizer.v2.InitiateResponse
 */
export type InitiateResponseJson = {
  /**
   * @generated from field: creativefabrica.vectorizer.v2.Session session = 1;
   */
  session?: SessionJson;

  /**
   * @generated from field: repeated creativefabrica.vectorizer.v2.BatchUrlResponseItem urls = 2;
   */
  urls?: BatchUrlResponseItemJson[];
};

/**
 * Describes the message creativefabrica.vectorizer.v2.InitiateResponse.
 * Use `create(InitiateResponseSchema)` to create a new message.
 */
export const InitiateResponseSchema: GenMessage<InitiateResponse, {jsonType: InitiateResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 5);

/**
 * @generated from message creativefabrica.vectorizer.v2.BatchUrlRequestItem
 */
export type BatchUrlRequestItem = Message<"creativefabrica.vectorizer.v2.BatchUrlRequestItem"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize: bigint;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.BatchUrlRequestItem
 */
export type BatchUrlRequestItemJson = {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 2;
   */
  fileSize?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.BatchUrlRequestItem.
 * Use `create(BatchUrlRequestItemSchema)` to create a new message.
 */
export const BatchUrlRequestItemSchema: GenMessage<BatchUrlRequestItem, {jsonType: BatchUrlRequestItemJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 6);

/**
 * @generated from message creativefabrica.vectorizer.v2.BatchUrlResponseItem
 */
export type BatchUrlResponseItem = Message<"creativefabrica.vectorizer.v2.BatchUrlResponseItem"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.BatchUrlResponseItem
 */
export type BatchUrlResponseItemJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: string url = 2;
   */
  url?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.BatchUrlResponseItem.
 * Use `create(BatchUrlResponseItemSchema)` to create a new message.
 */
export const BatchUrlResponseItemSchema: GenMessage<BatchUrlResponseItem, {jsonType: BatchUrlResponseItemJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 7);

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishSessionRequest
 */
export type PublishSessionRequest = Message<"creativefabrica.vectorizer.v2.PublishSessionRequest"> & {
  /**
   * @generated from oneof creativefabrica.vectorizer.v2.PublishSessionRequest.ids
   */
  ids: {
    /**
     * @generated from field: string session_id = 1;
     */
    value: string;
    case: "sessionId";
  } | {
    /**
     * @generated from field: creativefabrica.vectorizer.v2.PublishSessionRequest.Images image_ids = 2;
     */
    value: PublishSessionRequest_Images;
    case: "imageIds";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishSessionRequest
 */
export type PublishSessionRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.PublishSessionRequest.Images image_ids = 2;
   */
  imageIds?: PublishSessionRequest_ImagesJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.PublishSessionRequest.
 * Use `create(PublishSessionRequestSchema)` to create a new message.
 */
export const PublishSessionRequestSchema: GenMessage<PublishSessionRequest, {jsonType: PublishSessionRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 8);

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishSessionRequest.Images
 */
export type PublishSessionRequest_Images = Message<"creativefabrica.vectorizer.v2.PublishSessionRequest.Images"> & {
  /**
   * @generated from field: repeated string image_id = 1;
   */
  imageId: string[];
};

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishSessionRequest.Images
 */
export type PublishSessionRequest_ImagesJson = {
  /**
   * @generated from field: repeated string image_id = 1;
   */
  imageId?: string[];
};

/**
 * Describes the message creativefabrica.vectorizer.v2.PublishSessionRequest.Images.
 * Use `create(PublishSessionRequest_ImagesSchema)` to create a new message.
 */
export const PublishSessionRequest_ImagesSchema: GenMessage<PublishSessionRequest_Images, {jsonType: PublishSessionRequest_ImagesJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 8, 0);

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishSessionResponse
 */
export type PublishSessionResponse = Message<"creativefabrica.vectorizer.v2.PublishSessionResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.vectorizer.v2.PublishImageResponse images = 1;
   */
  images: PublishImageResponse[];
};

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishSessionResponse
 */
export type PublishSessionResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.vectorizer.v2.PublishImageResponse images = 1;
   */
  images?: PublishImageResponseJson[];
};

/**
 * Describes the message creativefabrica.vectorizer.v2.PublishSessionResponse.
 * Use `create(PublishSessionResponseSchema)` to create a new message.
 */
export const PublishSessionResponseSchema: GenMessage<PublishSessionResponse, {jsonType: PublishSessionResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 9);

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishImageResponse
 */
export type PublishImageResponse = Message<"creativefabrica.vectorizer.v2.PublishImageResponse"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishImageResponse
 */
export type PublishImageResponseJson = {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.PublishImageResponse.
 * Use `create(PublishImageResponseSchema)` to create a new message.
 */
export const PublishImageResponseSchema: GenMessage<PublishImageResponse, {jsonType: PublishImageResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 10);

/**
 * @generated from message creativefabrica.vectorizer.v2.CreateSignedUrlRequest
 * @deprecated
 */
export type CreateSignedUrlRequest = Message<"creativefabrica.vectorizer.v2.CreateSignedUrlRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize: bigint;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.CreateSignedUrlRequest
 * @deprecated
 */
export type CreateSignedUrlRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 3;
   */
  fileSize?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.CreateSignedUrlRequest.
 * Use `create(CreateSignedUrlRequestSchema)` to create a new message.
 * @deprecated
 */
export const CreateSignedUrlRequestSchema: GenMessage<CreateSignedUrlRequest, {jsonType: CreateSignedUrlRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 11);

/**
 * @generated from message creativefabrica.vectorizer.v2.CreateSignedUrlResponse
 * @deprecated
 */
export type CreateSignedUrlResponse = Message<"creativefabrica.vectorizer.v2.CreateSignedUrlResponse"> & {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.CreateSignedUrlResponse
 * @deprecated
 */
export type CreateSignedUrlResponseJson = {
  /**
   * @generated from field: string upload_id = 1;
   */
  uploadId?: string;

  /**
   * @generated from field: string url = 2;
   */
  url?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.CreateSignedUrlResponse.
 * Use `create(CreateSignedUrlResponseSchema)` to create a new message.
 * @deprecated
 */
export const CreateSignedUrlResponseSchema: GenMessage<CreateSignedUrlResponse, {jsonType: CreateSignedUrlResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 12);

/**
 * @generated from message creativefabrica.vectorizer.v2.VectorizeRequest
 * @deprecated
 */
export type VectorizeRequest = Message<"creativefabrica.vectorizer.v2.VectorizeRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.VectorizeRequest
 * @deprecated
 */
export type VectorizeRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.VectorizeRequest.
 * Use `create(VectorizeRequestSchema)` to create a new message.
 * @deprecated
 */
export const VectorizeRequestSchema: GenMessage<VectorizeRequest, {jsonType: VectorizeRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 13);

/**
 * @generated from message creativefabrica.vectorizer.v2.VectorizeResponse
 * @deprecated
 */
export type VectorizeResponse = Message<"creativefabrica.vectorizer.v2.VectorizeResponse"> & {
};

/**
 * @generated from message creativefabrica.vectorizer.v2.VectorizeResponse
 * @deprecated
 */
export type VectorizeResponseJson = {
};

/**
 * Describes the message creativefabrica.vectorizer.v2.VectorizeResponse.
 * Use `create(VectorizeResponseSchema)` to create a new message.
 * @deprecated
 */
export const VectorizeResponseSchema: GenMessage<VectorizeResponse, {jsonType: VectorizeResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 14);

/**
 * @generated from message creativefabrica.vectorizer.v2.ListRequest
 */
export type ListRequest = Message<"creativefabrica.vectorizer.v2.ListRequest"> & {
  /**
   * @generated from field: string after_id = 2 [deprecated = true];
   * @deprecated
   */
  afterId: string;

  /**
   * @generated from field: int32 take = 3 [deprecated = true];
   * @deprecated
   */
  take: number;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 4;
   */
  pagination?: PaginationRequest | undefined;

  /**
   * Lists only sessions created on this surface. Unspecified means studio,
   * which is also where sessions predating surface scoping are attributed.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 5;
   */
  surface: Surface;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.ListRequest
 */
export type ListRequestJson = {
  /**
   * @generated from field: string after_id = 2 [deprecated = true];
   * @deprecated
   */
  afterId?: string;

  /**
   * @generated from field: int32 take = 3 [deprecated = true];
   * @deprecated
   */
  take?: number;

  /**
   * @generated from field: creativefabrica.common.v1.PaginationRequest pagination = 4;
   */
  pagination?: PaginationRequestJson;

  /**
   * Lists only sessions created on this surface. Unspecified means studio,
   * which is also where sessions predating surface scoping are attributed.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 5;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest, {jsonType: ListRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 15);

/**
 * @generated from message creativefabrica.vectorizer.v2.ListResponse
 */
export type ListResponse = Message<"creativefabrica.vectorizer.v2.ListResponse"> & {
  /**
   * @generated from field: repeated creativefabrica.vectorizer.v2.Session sessions = 1;
   */
  sessions: Session[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponse | undefined;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.ListResponse
 */
export type ListResponseJson = {
  /**
   * @generated from field: repeated creativefabrica.vectorizer.v2.Session sessions = 1;
   */
  sessions?: SessionJson[];

  /**
   * @generated from field: creativefabrica.common.v1.PaginationResponse pagination = 2;
   */
  pagination?: PaginationResponseJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.ListResponse.
 * Use `create(ListResponseSchema)` to create a new message.
 */
export const ListResponseSchema: GenMessage<ListResponse, {jsonType: ListResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 16);

/**
 * @generated from message creativefabrica.vectorizer.v2.GetRequest
 */
export type GetRequest = Message<"creativefabrica.vectorizer.v2.GetRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.GetRequest
 */
export type GetRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.GetRequest.
 * Use `create(GetRequestSchema)` to create a new message.
 */
export const GetRequestSchema: GenMessage<GetRequest, {jsonType: GetRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 17);

/**
 * @generated from message creativefabrica.vectorizer.v2.GetResponse
 */
export type GetResponse = Message<"creativefabrica.vectorizer.v2.GetResponse"> & {
  /**
   * @generated from field: creativefabrica.vectorizer.v2.Session session = 1;
   */
  session?: Session | undefined;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.GetResponse
 */
export type GetResponseJson = {
  /**
   * @generated from field: creativefabrica.vectorizer.v2.Session session = 1;
   */
  session?: SessionJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.GetResponse.
 * Use `create(GetResponseSchema)` to create a new message.
 */
export const GetResponseSchema: GenMessage<GetResponse, {jsonType: GetResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 18);

/**
 * @generated from message creativefabrica.vectorizer.v2.DownloadRequest
 */
export type DownloadRequest = Message<"creativefabrica.vectorizer.v2.DownloadRequest"> & {
  /**
   * @generated from oneof creativefabrica.vectorizer.v2.DownloadRequest.download
   */
  download: {
    /**
     * @generated from field: string session_id = 1;
     */
    value: string;
    case: "sessionId";
  } | {
    /**
     * @generated from field: creativefabrica.vectorizer.v2.DownloadRequest.ImageIds image_ids = 2;
     */
    value: DownloadRequest_ImageIds;
    case: "imageIds";
  } | { case: undefined; value?: undefined };

  /**
   * Surface the download is requested from. It selects the billing origin —
   * marketplace requires All Access, studio requires Studio AI — and must match
   * the surface the images were created on. Unspecified means studio.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface: Surface;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.DownloadRequest
 */
export type DownloadRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.DownloadRequest.ImageIds image_ids = 2;
   */
  imageIds?: DownloadRequest_ImageIdsJson;

  /**
   * Surface the download is requested from. It selects the billing origin —
   * marketplace requires All Access, studio requires Studio AI — and must match
   * the surface the images were created on. Unspecified means studio.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 3;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.DownloadRequest.
 * Use `create(DownloadRequestSchema)` to create a new message.
 */
export const DownloadRequestSchema: GenMessage<DownloadRequest, {jsonType: DownloadRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 19);

/**
 * @generated from message creativefabrica.vectorizer.v2.DownloadRequest.ImageIds
 */
export type DownloadRequest_ImageIds = Message<"creativefabrica.vectorizer.v2.DownloadRequest.ImageIds"> & {
  /**
   * @generated from field: repeated string image_ids = 1;
   */
  imageIds: string[];
};

/**
 * @generated from message creativefabrica.vectorizer.v2.DownloadRequest.ImageIds
 */
export type DownloadRequest_ImageIdsJson = {
  /**
   * @generated from field: repeated string image_ids = 1;
   */
  imageIds?: string[];
};

/**
 * Describes the message creativefabrica.vectorizer.v2.DownloadRequest.ImageIds.
 * Use `create(DownloadRequest_ImageIdsSchema)` to create a new message.
 */
export const DownloadRequest_ImageIdsSchema: GenMessage<DownloadRequest_ImageIds, {jsonType: DownloadRequest_ImageIdsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 19, 0);

/**
 * @generated from message creativefabrica.vectorizer.v2.DownloadResponse
 */
export type DownloadResponse = Message<"creativefabrica.vectorizer.v2.DownloadResponse"> & {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.DownloadResponse
 */
export type DownloadResponseJson = {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.DownloadResponse.
 * Use `create(DownloadResponseSchema)` to create a new message.
 */
export const DownloadResponseSchema: GenMessage<DownloadResponse, {jsonType: DownloadResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 20);

/**
 * @generated from message creativefabrica.vectorizer.v2.GetDownloadRequest
 */
export type GetDownloadRequest = Message<"creativefabrica.vectorizer.v2.GetDownloadRequest"> & {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.GetDownloadRequest
 */
export type GetDownloadRequestJson = {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.GetDownloadRequest.
 * Use `create(GetDownloadRequestSchema)` to create a new message.
 */
export const GetDownloadRequestSchema: GenMessage<GetDownloadRequest, {jsonType: GetDownloadRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 21);

/**
 * @generated from message creativefabrica.vectorizer.v2.GetDownloadResponse
 */
export type GetDownloadResponse = Message<"creativefabrica.vectorizer.v2.GetDownloadResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.DownloadStatus status = 3;
   */
  status: DownloadStatus;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 5;
   */
  requestedAt?: Timestamp | undefined;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.GetDownloadResponse
 */
export type GetDownloadResponseJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.DownloadStatus status = 3;
   */
  status?: DownloadStatusJson;

  /**
   * @generated from field: string url = 4;
   */
  url?: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 5;
   */
  requestedAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.GetDownloadResponse.
 * Use `create(GetDownloadResponseSchema)` to create a new message.
 */
export const GetDownloadResponseSchema: GenMessage<GetDownloadResponse, {jsonType: GetDownloadResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 22);

/**
 * @generated from message creativefabrica.vectorizer.v2.Download
 */
export type Download = Message<"creativefabrica.vectorizer.v2.Download"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.DownloadStatus status = 3;
   */
  status: DownloadStatus;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 5;
   */
  requestedAt?: Timestamp | undefined;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.Download
 */
export type DownloadJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.DownloadStatus status = 3;
   */
  status?: DownloadStatusJson;

  /**
   * @generated from field: string url = 4;
   */
  url?: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 5;
   */
  requestedAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.Download.
 * Use `create(DownloadSchema)` to create a new message.
 */
export const DownloadSchema: GenMessage<Download, {jsonType: DownloadJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 23);

/**
 * @generated from message creativefabrica.vectorizer.v2.Session
 */
export type Session = Message<"creativefabrica.vectorizer.v2.Session"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.SessionStatus status = 3;
   */
  status: SessionStatus;

  /**
   * @generated from field: uint32 images = 4;
   */
  images: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 6;
   */
  requestedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 7;
   */
  finishedAt?: Timestamp | undefined;

  /**
   * @generated from field: string thumbnail_url = 8;
   */
  thumbnailUrl: string;

  /**
   * Surface the session was created on; sessions predating surface scoping
   * read back as studio.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 9;
   */
  surface: Surface;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.Session
 */
export type SessionJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.SessionStatus status = 3;
   */
  status?: SessionStatusJson;

  /**
   * @generated from field: uint32 images = 4;
   */
  images?: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 6;
   */
  requestedAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 7;
   */
  finishedAt?: TimestampJson;

  /**
   * @generated from field: string thumbnail_url = 8;
   */
  thumbnailUrl?: string;

  /**
   * Surface the session was created on; sessions predating surface scoping
   * read back as studio.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 9;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session, {jsonType: SessionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 24);

/**
 * @generated from message creativefabrica.vectorizer.v2.Image
 */
export type Image = Message<"creativefabrica.vectorizer.v2.Image"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string original_url = 3;
   */
  originalUrl: string;

  /**
   * @generated from field: string response_url = 4;
   */
  responseUrl: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName: string;

  /**
   * @generated from field: string thumbnail_url = 6;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.ImageStatus status = 7;
   */
  status: ImageStatus;

  /**
   * @generated from field: string error_message = 8;
   */
  errorMessage: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 9;
   */
  requestedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 10;
   */
  receivedAt?: Timestamp | undefined;

  /**
   * @generated from field: string session_id = 11;
   */
  sessionId: string;

  /**
   * Surface the image was created on; images predating surface scoping read
   * back as studio.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 12;
   */
  surface: Surface;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.Image
 */
export type ImageJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string original_url = 3;
   */
  originalUrl?: string;

  /**
   * @generated from field: string response_url = 4;
   */
  responseUrl?: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName?: string;

  /**
   * @generated from field: string thumbnail_url = 6;
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.ImageStatus status = 7;
   */
  status?: ImageStatusJson;

  /**
   * @generated from field: string error_message = 8;
   */
  errorMessage?: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 9;
   */
  requestedAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp received_at = 10;
   */
  receivedAt?: TimestampJson;

  /**
   * @generated from field: string session_id = 11;
   */
  sessionId?: string;

  /**
   * Surface the image was created on; images predating surface scoping read
   * back as studio.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 12;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image, {jsonType: ImageJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 25);

/**
 * @generated from message creativefabrica.vectorizer.v2.OnVectorizationCompletedRequest
 */
export type OnVectorizationCompletedRequest = Message<"creativefabrica.vectorizer.v2.OnVectorizationCompletedRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string response_url = 2;
   */
  responseUrl: string;

  /**
   * @generated from field: string thumbnail_url = 3;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: string error_message = 4;
   */
  errorMessage: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.ErrorCode error_code = 5;
   */
  errorCode: ErrorCode;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.OnVectorizationCompletedRequest
 */
export type OnVectorizationCompletedRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string response_url = 2;
   */
  responseUrl?: string;

  /**
   * @generated from field: string thumbnail_url = 3;
   */
  thumbnailUrl?: string;

  /**
   * @generated from field: string error_message = 4;
   */
  errorMessage?: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.ErrorCode error_code = 5;
   */
  errorCode?: ErrorCodeJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.OnVectorizationCompletedRequest.
 * Use `create(OnVectorizationCompletedRequestSchema)` to create a new message.
 */
export const OnVectorizationCompletedRequestSchema: GenMessage<OnVectorizationCompletedRequest, {jsonType: OnVectorizationCompletedRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 26);

/**
 * @generated from message creativefabrica.vectorizer.v2.OnVectorizationCompletedResponse
 */
export type OnVectorizationCompletedResponse = Message<"creativefabrica.vectorizer.v2.OnVectorizationCompletedResponse"> & {
};

/**
 * @generated from message creativefabrica.vectorizer.v2.OnVectorizationCompletedResponse
 */
export type OnVectorizationCompletedResponseJson = {
};

/**
 * Describes the message creativefabrica.vectorizer.v2.OnVectorizationCompletedResponse.
 * Use `create(OnVectorizationCompletedResponseSchema)` to create a new message.
 */
export const OnVectorizationCompletedResponseSchema: GenMessage<OnVectorizationCompletedResponse, {jsonType: OnVectorizationCompletedResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 27);

/**
 * @generated from message creativefabrica.vectorizer.v2.DownloadProcessRequest
 */
export type DownloadProcessRequest = Message<"creativefabrica.vectorizer.v2.DownloadProcessRequest"> & {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.DownloadProcessRequest
 */
export type DownloadProcessRequestJson = {
  /**
   * @generated from field: string download_id = 1;
   */
  downloadId?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.DownloadProcessRequest.
 * Use `create(DownloadProcessRequestSchema)` to create a new message.
 */
export const DownloadProcessRequestSchema: GenMessage<DownloadProcessRequest, {jsonType: DownloadProcessRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 28);

/**
 * @generated from message creativefabrica.vectorizer.v2.DownloadProcessResponse
 */
export type DownloadProcessResponse = Message<"creativefabrica.vectorizer.v2.DownloadProcessResponse"> & {
};

/**
 * @generated from message creativefabrica.vectorizer.v2.DownloadProcessResponse
 */
export type DownloadProcessResponseJson = {
};

/**
 * Describes the message creativefabrica.vectorizer.v2.DownloadProcessResponse.
 * Use `create(DownloadProcessResponseSchema)` to create a new message.
 */
export const DownloadProcessResponseSchema: GenMessage<DownloadProcessResponse, {jsonType: DownloadProcessResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 29);

/**
 * @generated from message creativefabrica.vectorizer.v2.DeleteRequest
 */
export type DeleteRequest = Message<"creativefabrica.vectorizer.v2.DeleteRequest"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.DeleteRequest
 */
export type DeleteRequestJson = {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.DeleteRequest.
 * Use `create(DeleteRequestSchema)` to create a new message.
 */
export const DeleteRequestSchema: GenMessage<DeleteRequest, {jsonType: DeleteRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 30);

/**
 * @generated from message creativefabrica.vectorizer.v2.DeleteResponse
 */
export type DeleteResponse = Message<"creativefabrica.vectorizer.v2.DeleteResponse"> & {
};

/**
 * @generated from message creativefabrica.vectorizer.v2.DeleteResponse
 */
export type DeleteResponseJson = {
};

/**
 * Describes the message creativefabrica.vectorizer.v2.DeleteResponse.
 * Use `create(DeleteResponseSchema)` to create a new message.
 */
export const DeleteResponseSchema: GenMessage<DeleteResponse, {jsonType: DeleteResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 31);

/**
 * @generated from message creativefabrica.vectorizer.v2.DeleteAllRequest
 */
export type DeleteAllRequest = Message<"creativefabrica.vectorizer.v2.DeleteAllRequest"> & {
  /**
   * Deletes only sessions created on this surface. Unspecified means studio.
   * Only studio and marketplace are accepted.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 1;
   */
  surface: Surface;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.DeleteAllRequest
 */
export type DeleteAllRequestJson = {
  /**
   * Deletes only sessions created on this surface. Unspecified means studio.
   * Only studio and marketplace are accepted.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 1;
   */
  surface?: SurfaceJson;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.DeleteAllRequest.
 * Use `create(DeleteAllRequestSchema)` to create a new message.
 */
export const DeleteAllRequestSchema: GenMessage<DeleteAllRequest, {jsonType: DeleteAllRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 32);

/**
 * @generated from message creativefabrica.vectorizer.v2.DeleteAllResponse
 */
export type DeleteAllResponse = Message<"creativefabrica.vectorizer.v2.DeleteAllResponse"> & {
};

/**
 * @generated from message creativefabrica.vectorizer.v2.DeleteAllResponse
 */
export type DeleteAllResponseJson = {
};

/**
 * Describes the message creativefabrica.vectorizer.v2.DeleteAllResponse.
 * Use `create(DeleteAllResponseSchema)` to create a new message.
 */
export const DeleteAllResponseSchema: GenMessage<DeleteAllResponse, {jsonType: DeleteAllResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 33);

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishRequest
 */
export type PublishRequest = Message<"creativefabrica.vectorizer.v2.PublishRequest"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishRequest
 */
export type PublishRequestJson = {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.PublishRequest.
 * Use `create(PublishRequestSchema)` to create a new message.
 */
export const PublishRequestSchema: GenMessage<PublishRequest, {jsonType: PublishRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 34);

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishResponse
 */
export type PublishResponse = Message<"creativefabrica.vectorizer.v2.PublishResponse"> & {
};

/**
 * @generated from message creativefabrica.vectorizer.v2.PublishResponse
 */
export type PublishResponseJson = {
};

/**
 * Describes the message creativefabrica.vectorizer.v2.PublishResponse.
 * Use `create(PublishResponseSchema)` to create a new message.
 */
export const PublishResponseSchema: GenMessage<PublishResponse, {jsonType: PublishResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 35);

/**
 * @generated from message creativefabrica.vectorizer.v2.OnUploadCompletedRequest
 */
export type OnUploadCompletedRequest = Message<"creativefabrica.vectorizer.v2.OnUploadCompletedRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string upload_id = 2;
   */
  uploadId: string;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName: string;

  /**
   * @generated from field: int64 file_size = 6;
   */
  fileSize: bigint;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.UploadStatus status = 4;
   */
  status: UploadStatus;

  /**
   * @generated from field: string error_message = 7;
   */
  errorMessage: string;

  /**
   * @generated from field: string session_id = 8;
   */
  sessionId: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.OnUploadCompletedRequest
 */
export type OnUploadCompletedRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string upload_id = 2;
   */
  uploadId?: string;

  /**
   * @generated from field: string url = 3;
   */
  url?: string;

  /**
   * @generated from field: string file_name = 5;
   */
  fileName?: string;

  /**
   * @generated from field: int64 file_size = 6;
   */
  fileSize?: string;

  /**
   * @generated from field: creativefabrica.vectorizer.v2.UploadStatus status = 4;
   */
  status?: UploadStatusJson;

  /**
   * @generated from field: string error_message = 7;
   */
  errorMessage?: string;

  /**
   * @generated from field: string session_id = 8;
   */
  sessionId?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.OnUploadCompletedRequest.
 * Use `create(OnUploadCompletedRequestSchema)` to create a new message.
 */
export const OnUploadCompletedRequestSchema: GenMessage<OnUploadCompletedRequest, {jsonType: OnUploadCompletedRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 36);

/**
 * @generated from message creativefabrica.vectorizer.v2.OnUploadCompletedResponse
 */
export type OnUploadCompletedResponse = Message<"creativefabrica.vectorizer.v2.OnUploadCompletedResponse"> & {
};

/**
 * @generated from message creativefabrica.vectorizer.v2.OnUploadCompletedResponse
 */
export type OnUploadCompletedResponseJson = {
};

/**
 * Describes the message creativefabrica.vectorizer.v2.OnUploadCompletedResponse.
 * Use `create(OnUploadCompletedResponseSchema)` to create a new message.
 */
export const OnUploadCompletedResponseSchema: GenMessage<OnUploadCompletedResponse, {jsonType: OnUploadCompletedResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 37);

/**
 * @generated from message creativefabrica.vectorizer.v2.UserCleanupRequest
 */
export type UserCleanupRequest = Message<"creativefabrica.vectorizer.v2.UserCleanupRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message creativefabrica.vectorizer.v2.UserCleanupRequest
 */
export type UserCleanupRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message creativefabrica.vectorizer.v2.UserCleanupRequest.
 * Use `create(UserCleanupRequestSchema)` to create a new message.
 */
export const UserCleanupRequestSchema: GenMessage<UserCleanupRequest, {jsonType: UserCleanupRequestJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 38);

/**
 * @generated from message creativefabrica.vectorizer.v2.UserCleanupResponse
 */
export type UserCleanupResponse = Message<"creativefabrica.vectorizer.v2.UserCleanupResponse"> & {
};

/**
 * @generated from message creativefabrica.vectorizer.v2.UserCleanupResponse
 */
export type UserCleanupResponseJson = {
};

/**
 * Describes the message creativefabrica.vectorizer.v2.UserCleanupResponse.
 * Use `create(UserCleanupResponseSchema)` to create a new message.
 */
export const UserCleanupResponseSchema: GenMessage<UserCleanupResponse, {jsonType: UserCleanupResponseJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_vectorizer_v2_service, 39);

/**
 * @generated from enum creativefabrica.vectorizer.v2.ImageStatus
 */
export enum ImageStatus {
  /**
   * @generated from enum value: IMAGE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: IMAGE_STATUS_UPLOADED = 1;
   */
  UPLOADED = 1,

  /**
   * @generated from enum value: IMAGE_STATUS_REQUESTED = 2;
   */
  REQUESTED = 2,

  /**
   * @generated from enum value: IMAGE_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: IMAGE_STATUS_ERROR = 4;
   */
  ERROR = 4,
}

/**
 * @generated from enum creativefabrica.vectorizer.v2.ImageStatus
 */
export type ImageStatusJson = "IMAGE_STATUS_UNSPECIFIED" | "IMAGE_STATUS_UPLOADED" | "IMAGE_STATUS_REQUESTED" | "IMAGE_STATUS_COMPLETED" | "IMAGE_STATUS_ERROR";

/**
 * Describes the enum creativefabrica.vectorizer.v2.ImageStatus.
 */
export const ImageStatusSchema: GenEnum<ImageStatus, ImageStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_vectorizer_v2_service, 0);

/**
 * @generated from enum creativefabrica.vectorizer.v2.DownloadStatus
 */
export enum DownloadStatus {
  /**
   * @generated from enum value: DOWNLOAD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DOWNLOAD_STATUS_REQUESTED = 1;
   */
  REQUESTED = 1,

  /**
   * @generated from enum value: DOWNLOAD_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * @generated from enum value: DOWNLOAD_STATUS_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * @generated from enum creativefabrica.vectorizer.v2.DownloadStatus
 */
export type DownloadStatusJson = "DOWNLOAD_STATUS_UNSPECIFIED" | "DOWNLOAD_STATUS_REQUESTED" | "DOWNLOAD_STATUS_COMPLETED" | "DOWNLOAD_STATUS_ERROR";

/**
 * Describes the enum creativefabrica.vectorizer.v2.DownloadStatus.
 */
export const DownloadStatusSchema: GenEnum<DownloadStatus, DownloadStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_vectorizer_v2_service, 1);

/**
 * @generated from enum creativefabrica.vectorizer.v2.SessionStatus
 */
export enum SessionStatus {
  /**
   * @generated from enum value: SESSION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SESSION_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: SESSION_STATUS_REQUESTED = 2;
   */
  REQUESTED = 2,

  /**
   * @generated from enum value: SESSION_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: SESSION_STATUS_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * @generated from enum creativefabrica.vectorizer.v2.SessionStatus
 */
export type SessionStatusJson = "SESSION_STATUS_UNSPECIFIED" | "SESSION_STATUS_CREATED" | "SESSION_STATUS_REQUESTED" | "SESSION_STATUS_COMPLETED" | "SESSION_STATUS_FAILED";

/**
 * Describes the enum creativefabrica.vectorizer.v2.SessionStatus.
 */
export const SessionStatusSchema: GenEnum<SessionStatus, SessionStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_vectorizer_v2_service, 2);

/**
 * @generated from enum creativefabrica.vectorizer.v2.UploadStatus
 */
export enum UploadStatus {
  /**
   * @generated from enum value: UPLOAD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPLOAD_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: UPLOAD_STATUS_SUCCESS = 2;
   */
  SUCCESS = 2,

  /**
   * @generated from enum value: UPLOAD_STATUS_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * @generated from enum creativefabrica.vectorizer.v2.UploadStatus
 */
export type UploadStatusJson = "UPLOAD_STATUS_UNSPECIFIED" | "UPLOAD_STATUS_PENDING" | "UPLOAD_STATUS_SUCCESS" | "UPLOAD_STATUS_ERROR";

/**
 * Describes the enum creativefabrica.vectorizer.v2.UploadStatus.
 */
export const UploadStatusSchema: GenEnum<UploadStatus, UploadStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_vectorizer_v2_service, 3);

/**
 * @generated from enum creativefabrica.vectorizer.v2.ErrorCode
 */
export enum ErrorCode {
  /**
   * @generated from enum value: ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ERROR_CODE_TIMEOUT = 1;
   */
  TIMEOUT = 1,

  /**
   * @generated from enum value: ERROR_CODE_SAI_ERROR = 2;
   */
  SAI_ERROR = 2,

  /**
   * @generated from enum value: ERROR_CODE_INTERNAL_SERVER_ERROR = 3;
   */
  INTERNAL_SERVER_ERROR = 3,

  /**
   * @generated from enum value: ERROR_CODE_UPLOAD_EXPIRED = 4;
   */
  UPLOAD_EXPIRED = 4,

  /**
   * The provider rejected the input: attributable to the user's input, not a
   * service fault.
   *
   * @generated from enum value: ERROR_CODE_VALIDATION_ERROR = 5;
   */
  VALIDATION_ERROR = 5,

  /**
   * The generation failed on the provider's side (a device, the network or
   * genai): not the user's input and not a fault of the service recording it.
   *
   * @generated from enum value: ERROR_CODE_PROVIDER_ERROR = 6;
   */
  PROVIDER_ERROR = 6,
}

/**
 * @generated from enum creativefabrica.vectorizer.v2.ErrorCode
 */
export type ErrorCodeJson = "ERROR_CODE_UNSPECIFIED" | "ERROR_CODE_TIMEOUT" | "ERROR_CODE_SAI_ERROR" | "ERROR_CODE_INTERNAL_SERVER_ERROR" | "ERROR_CODE_UPLOAD_EXPIRED" | "ERROR_CODE_VALIDATION_ERROR" | "ERROR_CODE_PROVIDER_ERROR";

/**
 * Describes the enum creativefabrica.vectorizer.v2.ErrorCode.
 */
export const ErrorCodeSchema: GenEnum<ErrorCode, ErrorCodeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_vectorizer_v2_service, 4);

/**
 * @generated from service creativefabrica.vectorizer.v2.VectorizerService
 */
export const VectorizerService: GenService<{
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.Initiate
   */
  initiate: {
    methodKind: "unary";
    input: typeof InitiateRequestSchema;
    output: typeof InitiateResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.CreateSignedUrl
   * @deprecated
   */
  createSignedUrl: {
    methodKind: "unary";
    input: typeof CreateSignedUrlRequestSchema;
    output: typeof CreateSignedUrlResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.Vectorize
   * @deprecated
   */
  vectorize: {
    methodKind: "unary";
    input: typeof VectorizeRequestSchema;
    output: typeof VectorizeResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetRequestSchema;
    output: typeof GetResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.GetImages
   */
  getImages: {
    methodKind: "unary";
    input: typeof GetImagesRequestSchema;
    output: typeof GetImagesResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.Download
   */
  download: {
    methodKind: "unary";
    input: typeof DownloadRequestSchema;
    output: typeof DownloadResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.GetDownload
   */
  getDownload: {
    methodKind: "unary";
    input: typeof GetDownloadRequestSchema;
    output: typeof GetDownloadResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteRequestSchema;
    output: typeof DeleteResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.DeleteAll
   */
  deleteAll: {
    methodKind: "unary";
    input: typeof DeleteAllRequestSchema;
    output: typeof DeleteAllResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.Publish
   */
  publish: {
    methodKind: "unary";
    input: typeof PublishRequestSchema;
    output: typeof PublishResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerService.PublishSession
   */
  publishSession: {
    methodKind: "unary";
    input: typeof PublishSessionRequestSchema;
    output: typeof PublishSessionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_vectorizer_v2_service, 0);

/**
 * @generated from service creativefabrica.vectorizer.v2.VectorizerInternalService
 */
export const VectorizerInternalService: GenService<{
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerInternalService.OnVectorizationCompleted
   */
  onVectorizationCompleted: {
    methodKind: "unary";
    input: typeof OnVectorizationCompletedRequestSchema;
    output: typeof OnVectorizationCompletedResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerInternalService.DownloadProcess
   */
  downloadProcess: {
    methodKind: "unary";
    input: typeof DownloadProcessRequestSchema;
    output: typeof DownloadProcessResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerInternalService.OnUploadCompleted
   */
  onUploadCompleted: {
    methodKind: "unary";
    input: typeof OnUploadCompletedRequestSchema;
    output: typeof OnUploadCompletedResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerInternalService.MigrateAnonymousUser
   */
  migrateAnonymousUser: {
    methodKind: "unary";
    input: typeof MigrateAnonymousUserRequestSchema;
    output: typeof MigrateAnonymousUserResponseSchema;
  },
  /**
   * @generated from rpc creativefabrica.vectorizer.v2.VectorizerInternalService.UserCleanup
   */
  userCleanup: {
    methodKind: "unary";
    input: typeof UserCleanupRequestSchema;
    output: typeof UserCleanupResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_creativefabrica_vectorizer_v2_service, 1);

